var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#44486C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.1,
    height: 9.1,
    x: 4.9,
    y: 4.9,
    rx: 1.694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1 9.1h-.7A1.4 1.4 0 010 7.7V1.4A1.4 1.4 0 011.4 0h6.3a1.4 1.4 0 011.4 1.4v.7"
  }))));
}

export default __webpack_public_path__ + "./fonts/copy.8a8686d7e525396c910a9b5ea39c55b4.svg";
export { SvgCopy as ReactComponent };